import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { GlobalSearchModule } from '../global-search/global-search.module';
import { EmailDigestModule } from '../email-digest/email-digest.module';

import { homeComponents } from '../../components/home-components.index';
import { HomeComponent } from './home.component';
import { EntityDialogComponent } from '../../components/entity-dialog/entity-dialog.component';

import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { ResearchModule } from '../research/research.module';
import { ContactModule } from '../contact/contact.module';
import { ContactListModule } from '../contact-list/contact-list.module';
import { TemplateModule } from '../../components/template/template.module';
import { ThreadModule } from '../thread/thread.module';
import { HomeScreenModule } from '../home-screen/home-screen.module';
import { SortModule } from '../../components/sort/sort.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { EntityListModule } from '../entity-list/entity-list.module';
import { EntityScreenModule } from '../../components/entity-screen/entity-screen.module';
import { ContactScreenModule } from '../../components/contact-screen/contact-screen.module';
import { FileViewModule } from '../file-view/file-view.module';
import { PrintModule } from '../print/print.module';

import { WidgetsModule } from '../../widgets/widgets.module';

import { AuditLogModule } from '../../components/audit-log/audit-log.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TagInputModule } from 'ngx-chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoteDialogModule } from '../../components/note-dialog/note-dialog.module';
import { NoteAttachmentBufferModule } from '../../components/note-attachment-buffer/note-attachment-buffer.module';
import { SaveScreenDialogModule } from '../../components/save-screen-dialog/save-screen-dialog.module';
import { NoteAttachmentsModule } from '../../components/note-attachments/note-attachment.module';
import { EntityDialogModule } from '../../components/entity-dialog/entity-dialog.module';
import { ContactDialogModule } from '../../components/contact-dialog/contact-dialog.module';
import { SlideSheetModule } from '../../components/slide-sheet/slide-sheet.module';
import { WorkflowModule } from '../workflow/workflow.module';
import { CalendarScreenModule } from '../../components/calendar-screen/calendar-screen.module';
import { CalendarWrapperModule } from '../calendar/calendar-wrapper/calendar-wrapper/calendar-wrapper.module';
import { CalendarDialogModule } from '../../components/calendar-dialog/calendar-dialog.module';
import { ThreadSideSheetModule } from '../../components/thread-side-sheet/thread-side-sheet.module';
import { EffectsModule } from '@ngrx/effects';
import { WorkflowEffects } from '../../tamalelibs/redux/effects/workflow.effects';
import { WorkflowTaskEffects } from '../../tamalelibs/redux/effects/workflow-task.effects';
import { ContactDialogModuleNew } from '../../components/contact-dialog-new/contact-dialog.module';
import { DraftListItemModule } from '../../components/draft-list-item/draft-list-item.module';
import { BottomSlideSheetModule } from '../../components/bottom-slide-sheet/bottom-slide-sheet.module';
import { IntralinksAccountDialogModule } from '../../components/intralinks-account-dialog/intralinks-account-dialog.module';
import { FeedsModule } from '../feeds/feeds.module';
import { BlastEmailModule } from '../feeds/blastemail/blastemail.module';
import { AutoTagModelDialogModule } from '../../components/admin-pages/admin-page-content/autotag-model-dialog/autotag-model-dialog.module';
import { DuplicateContactDialogModule } from '../../components/duplicated-contact-dialog/duplicated-contact-dialog.module';
import { IntralinksMappingDialogModule } from '../../components/intralinks-mapping-dialog/intralinks-mapping-dialog.module';
import { TemplateSettingDialogModule } from '../../components/template-setting-dialog/template-setting-dialog.module';
import { ContactDialogComponent } from '../../components/contact-dialog/contact-dialog.component';
import { ThreadFilterDialogModule } from '../../components/thread-filter/thread-filter.module';
import { EntityListEffects } from '../../redux/effects/entity-list.effects';
import { globalServices } from '../../services/service.index';
import { ContactEffects } from '../../tamalelibs/redux/contact.effects';
import { DraftViewEffects } from '../../redux/effects/draft-view.effect';
import { ContactListEffects } from '../../redux/effects/contact-list.effects';
import { EntryTemplateWebEffects } from '../../redux/effects/template-web.effects';
import { EntityTypeEffects } from '../../redux/effects/entity-type.effects';
import { EntryTypeEffects } from '../../redux/effects/entry-type.effects';
import { NoteOptionEffects } from '../../tamalelibs/redux/note.effects';
import { RelationshipTypeEffects } from '../../redux/effects/relationship-type.effects';
import { SystemEffects } from '../../redux/effects/system.effects';
import { TeamsEffects } from '../../redux/effects/teams.effects';
import { UsersEffects } from '../../redux/effects/users.effects';
import { AdhocEffects } from '../../redux/effects/adhoc.effects';
import { MarketdataEffects } from '../../redux/effects/marketdata.effects';
import { DataproviderEffects } from '../../redux/effects/dataprovider.effects';
import { SubChromeNameEffects } from '../../redux/effects/sub-chrome-name.effects';
import { EntityWebEffects } from '../../redux/effects/entity.effects';
import { IntralinksEffects } from '../../tamalelibs/redux/intralinks.effects';
import { MDLTemplateEffects } from '../../redux/effects/mdl-template.effects';
import { TemplateFieldsEffects } from '../../redux/effects/template-field.effects';
import { AgmDirectionModule } from 'agm-direction';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { AgGridModule } from 'ag-grid-angular';
import { AgmCoreModule } from '@agm/core';
import { SettingsModule } from '../settings/settings.module';
import { AutoTaggingEffects } from '../../tamalelibs/redux/auto-tagging.effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from '../../services/http-interceptors.service';
import { MapTileEffects } from '../../tamalelibs/redux/map-tile.effects';
import { businessConstants } from '../../constants/business.constants';
import { MapTileDialogModule } from '../../components/map-tile-dialog/map-tile-dialog.module';
import { NotificationEffects } from '../../redux/effects/notification.effects';
import { AaclKeywordSearchModule } from 'aacl-keyword-search';
import { RecipientListFilter } from '../../tamalelibs/pipes/recipient-list.pipe';
import { PortfolioEffects } from '../../redux/effects/portfolio.effects';
import { EntityAssociatedInfoModule } from '../entity-list/entity-associated-info.module';
import { AppendEntitiesDialogModule } from '../../components/append-entities-dialog/append-entities-dialog.module';
import { AppendEntityConfirmDialogModule } from '../../components/append-entity-confirm-dialog/append-entity-confirm-dialog.module';

@NgModule({
    imports: [
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        // 3rd part
        TagInputModule,
        InfiniteScrollModule,
        AgGridModule,
        AgmDirectionModule,
        ContextMenuModule,
        DeviceDetectorModule,
        // project in app
        AppendEntitiesDialogModule,
        AppendEntityConfirmDialogModule,
        AutoTagModelDialogModule,
        HomeRoutingModule,
        GlobalSearchModule,
        EmailDigestModule,
        SettingsModule,
        EntityAssociatedInfoModule,
        EntityListModule,
        BlastEmailModule,
        FeedsModule,
        AuditLogModule,
        DashboardModule,
        FileViewModule,
        DraftListItemModule,
        SortModule,
        EntityScreenModule,
        ContactScreenModule,
        WidgetsModule,
        ResearchModule,
        ThreadModule,
        ContactModule,
        ContactListModule,
        TemplateModule,
        HomeScreenModule,
        PrintModule,
        ThreadSideSheetModule,
        DuplicateContactDialogModule,
        EntityDialogModule,
        NoteAttachmentsModule,
        SaveScreenDialogModule,
        SettingsModule,
        NoteAttachmentBufferModule,
        NoteDialogModule,
        SlideSheetModule,
        WorkflowModule,
        CalendarDialogModule,
        CalendarScreenModule,
        ContactDialogModule,
        ContactDialogModuleNew,
        ThreadFilterDialogModule,
        BottomSlideSheetModule,
        CalendarWrapperModule,
        IntralinksAccountDialogModule,
        IntralinksMappingDialogModule,
        // MapTileDialogModule,
        AgmCoreModule.forRoot({
            apiKey: businessConstants.agmApiKey,
            libraries: ['places']
        }),
        AgmDirectionModule,
        // ngrx modules
        EffectsModule.forFeature([
            AdhocEffects,
            AutoTaggingEffects,
            ContactEffects,
            ContactListEffects,
            DataproviderEffects,
            DraftViewEffects,
            EntityListEffects,
            EntityWebEffects,
            EntryTemplateWebEffects,
            EntityTypeEffects,
            EntryTypeEffects,
            IntralinksEffects,
            MarketdataEffects,
            MDLTemplateEffects,
            NoteOptionEffects,
            RelationshipTypeEffects,
            NotificationEffects,
            PortfolioEffects,
            SystemEffects,
            SubChromeNameEffects,
            TemplateFieldsEffects,
            TeamsEffects,
            UsersEffects,
            WorkflowEffects,
            WorkflowTaskEffects,
            MapTileEffects,
        ]),
        TemplateSettingDialogModule,
        AaclKeywordSearchModule,
    ],
    declarations: [
        ...homeComponents,
        HomeComponent,
        RecipientListFilter
    ],
    providers: [
        ...globalServices,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
    ]
})
export class HomeModule { }
